import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ALREADY_HANDLED = Symbol('ALREADY_HANDLED');
export var GlobalErrorsManager = /*#__PURE__*/function () {
  function GlobalErrorsManager() {
    var _this = this;

    _classCallCheck(this, GlobalErrorsManager);

    this._listeners = [];
    window.addEventListener('error', function (e) {
      var shouldPreventDefault = _this._handleError(e.error);

      if (shouldPreventDefault) e.preventDefault();
    });
    window.addEventListener('unhandledrejection', function (e) {
      var error = e.reason instanceof Error ? e.reason : new Error(e.reason);

      var shouldPreventDefault = _this._handleError(error);

      if (shouldPreventDefault) e.preventDefault();
    });
  }

  _createClass(GlobalErrorsManager, [{
    key: "addListener",
    value: function addListener(listener) {
      this._listeners.push(listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(listener) {
      var index = this._listeners.findIndex(function (l) {
        return l === listener;
      });

      if (index >= 0) this._listeners.splice(index, 1);
    }
  }, {
    key: "throw",
    value: function _throw(error) {
      this._handleError(error);
    }
  }, {
    key: "_handleError",
    value: function _handleError(error) {
      if (error == null) return false;
      if (Reflect.get(error, ALREADY_HANDLED)) return true;

      var _iterator = _createForOfIteratorHelper(this._listeners.slice().reverse()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var l = _step.value;

          if (error != null && l(error)) {
            Reflect.set(error, ALREADY_HANDLED, true);
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Reflect.set(error, ALREADY_HANDLED, true);
      return false;
    }
  }]);

  return GlobalErrorsManager;
}();